import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { addProperties } from '../helper'
import { getInternationalCompany } from './thunk'

const slice = createSlice({
  name: 'internationalSearch/searchList',
  initialState: {
    data: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getInternationalCompany.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getInternationalCompany.fulfilled, (state, action) => {
      state.data = addProperties(action.payload)
      state.loading = false
    })
    builder.addCase(getInternationalCompany.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const selectData = (state) => state[slice.name].data
export const selectLoading = (state) => state[slice.name].loading

export const { changePageSize, changePage } = slice.actions

register(slice.name, slice.reducer)
